import zhLocal from 'vant/lib/locale/lang/zh-CN'
import zhJame from './languageJame/zh'
import zhGaea from './languageGaea/zh'
import zhAllen from './languageAllen/zh'
const zh = {
  300000: '新年送礼',
  300001: '2022新年送礼',
  300002: 'SuperEx和你一起过新年',
  300003: '尊敬的SuperEx用户：<br>为庆祝SuperEx在新年之际盛大上线,<br>平台将随机空投送出价值1,000,000 USDT新年大礼包。 <br>具体活动如下：',
  300004: '活动时间<br>加拿大时间：2022年01月01日00：00-02月15日23：59',
  300005: '活动一：分享海报获空投',
  300006: '分享活动海报至＞1000人的telegram加密货币群组，并附言“百万豪礼大派送，SuperEx和你一起过新年！或分享活动海报至个人Tiwwer，置顶并附言“百万豪礼大派送，SuperEx和你一起过新年！ ”上传截图给客服，将有机会获得5 ET（价值5 USDT）。',
  300007: '活动二：邀新获VIP',
  300008: '获得期间，用户通过邀请好友新注册并成功入金≥100 USDT即为有效邀请人数。成功邀请人数越多，所获VIP等级越高。有效期（30天）',
  300009: '活动三：新用户充值送',
  300010: '活动期间，新注册用户净充值金额达到一下区间并完成一笔交易，即可获得ET奖励。 （净充值金额在活动结束前以USDT结算）活动期间，新注册用户净充值金额达到一下区间并完成一笔交易，即可获得ET奖励。 （净充值金额在活动结束前以USDT结算）',
  300011: '注意事项：',
  300012: '1.每位参与用户只能获得一次奖励 <br>2.所有参与用户默认遵守SuperEx服务条款，如发现违规将立即停止其活动资格 <br>3.SuperEx有权在不提早通知用户的情况下修改本次活动的条款 <br>4.SuperEx将取消不合规用户活动参与资格并停用相关SuperEx账户使用 <br>5.SuperEx保留本次活动最终解释权',
  300013: '立即分享',
  300014: 'SuperEx团队',
  300015: '2022年01月01日',
  300016: '更多信息关注SuperEx官网：SuperEx.com',
  300017: '净充值金额（{coin}）',
  300018: '奖励金（{coin}）',
  300019: '180天',
  300020: '净充值=总入金金额-总出金金额',
  300021: 'ET持仓数量',
  300022: 'Maker/Taker',
  300023: '有效邀请人数',
  300024: '赠送有效期',
  300025: '活动获取条件',
  300026: '注：所有赠送的VIP等级均无需ET持仓要求。 ',
  300027: '复制成功',
  300028: '复制失败',

  300029: '下载 SuperEx APP',
  300030: '随时随地交易',
  300031: '创建SuperEx账户',
  300032: '若您已有SuperEx账户，请先登录',
  300033: '邮箱',
  300034: '手机',
  300035: '手机号',
  300036: '密码',
  300037: '推荐人ID(选填)',
  300038: '我已阅读并同意',
  300039: 'SuperEx服务条款',
  300040: '我已满18岁,并同意SuperEx服务条款',
  300041: '注册',
  300042: '安全验证',
  300043: '选择区号',
  300044: '搜索',
  300045: '请输入您的手机号',
  300046: '请输入正确的手机号码',
  300047: '请输入您的邮箱地址',
  300048: '请输入有效的电子邮件地址',
  300049: '请输入您的密码',
  300050: '至少8个字符，包含大写字母和数字',
  300051: '邮箱验证码',
  300052: '短信验证码',
  300053: '谷歌验证码',
  300054: '谷歌',
  300055: '为了您的账户安全,请完成以下验证操作',
  300056: '提交',
  300057: '6位验证码将发送至您的手机{phone}',
  300058: '6位验证码将发送至您的邮箱{email}',
  300059: '请输入6位SuperEx/谷歌/微软验证码',
  300060: '请输入6位验证码',
  300061: '发送验证码',
  300062: '{timeout}秒后重发',
  300063: '语言',
  300064: '审核中',
  300065: '请输入英文字母或常用标点符号',


  300066: '任务中心',
  300067: '返佣排名大作战',
  300068: '最高 <em class="bold normal" style="font-size: 1.2rem;color: #FFC72B;">1BTC</em> 等您领！',
  300069: '去邀请',
  300070: '排行榜',
  300071: '解锁规则',
  300072: '马上行动领ET',
  300073: '返佣排名大作战，最高1BTC等您领！',
  300074: '完成交易，解锁ET',
  300075: '完成以上所有任务可获白名单，官方将不定期随机向白名单用户空投大量ET。',
  300076: '活动日榜',
  300077: '活动累计榜',
  300078: '服务条款',
  300079: '我的奖励',

  300080: '冻结数量',
  300081: '解锁数量',
  300082: '解锁数量=手续费*解锁难度/ET价格',
  300083: '去交易',
  300084: '排名',
  300085: '账号',
  300086: '佣金数量',
  300087: '注：当日排名计算至当日00:00，次日发放奖金，数据可能存在误差仅供参考。',
  300088: '注：活动结束后3个工作日内发放，数据可能存在误差仅供参考。',
  300089: '查看更多',

  300090: '收起',
  300091: '您已是白名单用户！',
  300092: '请输入{type}账号',
  300093: '填写信息',
  300094: '立即关注twitter',
  300095: '立刻加入telegram',
  300096: '马上进行第一笔充值',
  300097: '马上进行第一笔现货交易',
  300098: '马上进行第一笔合约交易',
  300099: '立即推荐好友一起加入',

  300100: '协助好友进行交易',
  300101: '与好友一起领取更多',
  300102: '去充值',
  300103: '去关注',
  300104: '去领取',
  300105: '已领取（次）',
  300106: '暂未开放',
  300107: '加入社群',
  300108: '暂无数据',
  300109: '已完成',
  300110: '马上行动领SCS，推荐好友得更多',
  300111: '取消',
  300112: '提交',
  300113: '请勿重复提交',
  300114: '当前没有任务',
  300115: '更多任务敬请期待',
  300116: '更多活动敬请期待',
  300117: '绑定您的Twitter账户即可领取',
  300118: '绑定您的telegram账户即可领取',
  300119: '放弃',
  300120: '立即注册 SuperEx',
  300121: '去注册',
  300122: '已失效',
  300123: '白皮书',

  300124: '盲盒奖励',
  300125: '中奖率 <em class="normal bold" style="color: #FFC72B">100%</em> ，与朋友一起惊喜开盒',
  300126: '规则',

  300127: '开启盲盒',
  300128: '抽奖次数',
  300129: '剩余(我的)',
  300130: '已打开(总数USDT)',
  300131: '奖励',
  300132: '玩法介绍',
  300133: '分享您的邀请链接',
  300134: '完成任务',
  300135: '邀请好友注册，完成交易任务',
  300136: '领取盲盒',

  300137: '达成任务,获取盲盒',
  300138: '本次活动已结束，敬请期待下一次活动！',
  300139: '本次活动暂未开始，敬请期待！',
  300140: '活动规则',
  300141: '好的',
  300142: '时间',
  300143: '查詢',
  300144: '邮箱验证',
  300145: '邀请好友',
  300146: '点亮南瓜灯，玩转<em class="normal" style="color: #FFC72B">万圣节</em>',
  300147: '连续签到 <em class="normal" style="color: #FFC72B">{num}</em> 日，有机会赢取 <em class="normal" style="color: #FFC72B">{amount} ET</em> 大奖',
  300148: '中奖名单',
  300149: '每日签到',

  300150: '您已累计签到 {num} 天',
  300151: '抽大奖',
  300152: '已签到',
  300153: '签到',
  300154: '',
  300155: '',
  300156: '去补签',
  300157: '获得合约手续费抵扣券！',
  300158: 'VIP升级成功！',
  300159: '获得抽奖机会！',

  300160: '合约手续费抵扣券',
  300161: 'VIP升级',
  300162: '',
  300163: '您有<em class="normal" style="color: #FFC72B">{num}</em>次补签机会',
  300164: '获得补签机会',
  300165: '可补签',
  300166: '提示',
  300167: '补签成功',
  300168: '您还没有补签次数，当日净充值≥{num} {symbol} 即可获得1次补签机会',
  300169: '登录',

  300170: '补签已达上限',
  300171: '连续签到7天的用户中奖名单',
  300172: '连续签到可获得以下奖励',
  300173: '已领取',
  300174: '{num} 天',
  300175: '抵扣券',
  300176: 'VIP等级',
  300177: '参与抽奖',
  300178: '恭喜您!',
  300179: '签到成功',
  300180: '',
  300181: '学院',
  300182: '新闻',
  300183: '数据',
  300184: '学习',
  300185: '深入了解全球加密行业的重大事件',
  300186: '快速了解全球各地加密行业的最新事件',
  300187: '全面了解区块链、Web3 和加密货币',
  300188: '阅读更多',
  300189: '视频',
  300190: '正在加载',
  300191: '已经全部加载完毕',
  300192: '全部',
  300193: '赛事暂未进行',
  300194: '预测比赛冠军 赢取限定 <em class="normal" style="color: #DBFF00">奖金</em>',
  300195: '活动时间',
  300196: '投票记录',
  300197: '小组赛',
  300198: '{num}组',
  300199: '奖池: {num}',
  300200: '支持',
  300201: '淘汰赛',
  300202: '晋级',
  300203: '剩余投票截止时间',
  300204: '投票',
  300205: '请输入支持数量',
  300206: '最小竞猜数量：{num} ET',
  300207: '竞猜时间',
  300208: '竞猜球队',
  300209: '投入数量',
  300210: '中奖金额',
  300211: '出线球队',
  300212: '天',
  300213: '时',
  300214: '分',
  300215: '秒',
  300216: '场次',
  300217: '活动暂未开始',
  300218: '1/4决赛',
  300219: '确定',
  300220: '支持数量',
  300221: '余额不足',
  300222: '去充值',
  300223: '竞猜成功',
  300224: '1/8决赛',
  300225: '半决赛',
  300226: '三、四名决赛',
  300227: '决赛',
  300228: '胜',
  300229: '败',
  300230: '总奖池：{num} ET',
  300231: '查看更多场次',
  300232: '其它赛场',
  300233: '币种',
  300234: '最新价格',
  300235: '24H涨跌幅',
  300236: '新手指導',
  300237: '即刻開啟數字貨幣交易學習',
  300238: '全球運營',
  300239: '無國界，社區去中心化自治，團隊去中心化是SuperEx發展的終極形態',

  300240: '安全零風險',
  300241: '集成去中心化SuperWallet，私鑰加密存儲在用戶設備端。不受代碼安全、政治等因素影響',
  300242: '無需註冊&KYC',
  300243: '錢包授權即交易，無需註冊，無需KYC，交易清算都在鏈上完成，無法篡改，安全透明',
  300244: '開放系統',
  300245: '開放用戶與Dapp或智能合約進行交互，進入SuperWallet可授權參與Meta、Defi 、Nft等各種場景',
  300246: '太空基金',
  300247: '太空基金用於人類探索太空或資助於對人類探索太空有重大貢獻的機構或個人',
  300248: '安全、易用的數字貨幣市場',
  300249: '下載SuperEx手機應用程序，隨時關注市場，在完美的時刻進行交易，無論你身在何處。',

  300250: '更多下载选择',
  300251: '你的每一筆交易將助於我們推動人類對火星以及宇宙的探索！',
  300252: '立即注册',
  300253: 'iOS & Android<br>掃碼下載',
  300254: '身份验证器',
  300255: '驗證器會為您生成兩步驗證碼。 借助兩步驗證，讓您的SuperEx帳戶更加安全。',
  300256: 'SuperEx 验证器',
  300257: '谷歌验证器',
  300258: '微软验证器',
  300259: '下载客户端(iPhone)',

  300260: '下载客户端(Android)',
  300261: '全球最具信赖的数字资产交易平台',
  300262: '关于',
  300263: '服务协议',
  300264: '隐私条款',
  300265: '公告中心',
  300266: '学习',
  300267: '新手中心',
  300268: '现货交易',
  300269: '合约交易',

  300270: '常见问题',
  300271: '服务',
  300272: '费率标准',
  300273: '交易规则',
  300274: '上币申请',
  300275: '返佣',
  300276: '联系我们',
  300277: '帮助中心',
  300278: '提交工单',
  300279: '商务联络',

  300280: '机构合作',
  300281: '更多',
  300282: '欢迎回来',
  300283: '忘记密码?',
  300284: '还没有账号?',
  300285: '请前往APP或者电脑上进行找回密码的操作',
  300286: '我知道了',

  300287: '确认',
  300288: '待揭晓',
  300289: '待领取',

  300290: '已参与',
  300291: '已退款',
  300292: '购买规则',
  300293: '云购<span>好物</span>',
  300294: '购买参与',
  300295: '等待结果',
  300296: '领取商品',
  300297: '余额充值',
  300298: '购买记录',
  300299: '商品列表',
  300300: '单次参与费用',
  300301: '{num}份已售出，满{price} {currency}结束抢购',
  300302: '立即抢购',
  300303: '继续抢购',
  300304: '选择购买份数',
  300305: "1份需<span class='span'>{minPrice} {currency}</span>,单个商品最多可购",
  300306: '份',
  300307: '你有{num}{currency},购买份数越多购买成功概率越大',
  300308: '购买',
  300309: '错失良机',
  // 300309: '余额充值',
  300310: '恭喜您',
  300311: '去领取',
  300312: '再试一次',
  300313: '请在APP上执行充值或者P2P入金操作',
  // 300314: '我知道了',
  300315: '请在APP上联系客服来领取商品',
  // 300316: '我知道了',
  300317: '登录/注册',
  300318: '消耗{num} {currency}',
  300319: '商品介绍',
  300320: '我的参与',
  300321: '时间',
  300322: '参与商品',
  300323: '购买份数',
  300324: '退款金额',
  300325: '操作',
  300326: '去领取',
  300327: '已有帐号?',
  300328: '去登录',
  300329: '身份验证码',
  300330: '仅展示最近七天的记录',
  300331:'身份验证器',
  300332:'下载',
  300333:'1 USDT for 1 Bitcoin！',
  300334:"抢购价",
  300335:"往期揭晓",
  // 300336:"期次",
  300337:"查看规则",
  300338:"期次:【第{num}期】",
  300339:"购买流程",
  300340:"抢购成功用户",
  300341:"揭晓时间",
  300342:"分享",
  300343:"第[{num}]期",
  300345:"立即下载",
  300346:"炫耀一下",
  300347:"扫码参与",
  300348:"领取商品",
  300349:"提示:虚拟货币商品将在48小时内发到您的账号;",
  300350:"其他商品请联系客服领取",
  300351:"去查看",
  300352:"立刻报名",
  300353:"已报名",
  300354:'报名已结束',
  300355:'报名成功',
  300356:'打开App',
  300357:'恭喜{user}获得{shop}！',
  300358:'活动中心',
  300359:'正在进行',
  300360:'即将开始',
  300361:'已经结束',
  300362:'立即参与',
  300363: '已经结束',
  300364: '获奖名单',
  300365: '获奖名单即将揭晓',

  310000:'奖励总览',
  310001:'SCS 空投',

  300366: '货币',
  300367: '出售',
  200368: '支付',
  300369: '收到',
  300370: '获得',
  300371: '单笔限额:',
  300372: '付款方式',
  300373: '收款方式',
  300374: '支付渠道',
  300375: '订单详细信息',
  300376: '金额(含交易费用)',
  300377: '到达时间',
  300378: '免责声明',
  300379: '我已阅读并同意免责声明',
  300380: "您将离开SuperEx并跳转到Mercuryo，这是一家有执照的金融机构，作为第三方提供银行卡支付能力。使用中发生任何风险事件均由Mercuryo承担。在使用Mercuryo服务之前，请先阅读并同意其服务协议 如果您对信用卡押金有任何疑问，请联系 Mercuryo客服以了解更多详情。",
  300381: '如何在SuperEx上购买加密货币?',
  300382: '如何在SuperEx上出售加密货币？',
  300383: '下达加密货币订单',
  300384: '选择您想要支付的法定货币和您想要购买的加密货币。输入您想要花费的金额。',
  300385: '验证您的身份',
  300386: '在SuperEx和支付提供商上完成KYC验证，完成支付。',
  300387: '检查您的订单详细信息',
  300388: '检查您的存款历史记录以查看订单状态。',
  300389: '常见问题',
  300390: '1. 我可以使用哪些支付方式购买加密货币？',
  300391: 'SuperEx目前支持VISA、Mastercard、Apple Pay、Google Pay等多种支付方式。支持的第三方服务提供商包括 Mercuryo、alchemypay。',
  300392: '2. 我可以购买哪些加密货币？',
  300393: 'SuperEx supports mainstream cryptocurrencies such as BTC, ETH, USDT, LTC, EOS, XRP, BCH, ETC, and TRX.',
  300394: '3. SuperEx是否监控支持的第三方服务提供商的质量和价格？',
  300395: 'SuperEx精心挑选了一批具有值得信赖的行业信誉、知名度、安全性的服务提供商，为用户提供流程化的服务。',
  300396: '4. 购买加密货币需要支付哪些费用？',
  300397: '您向第三方服务提供商支付费用和链上转账费用。SuperEx不收取任何费用。',
  300398: '5. 付款后需要多长时间才能收到加密货币？',
  300399: '当您在第三方服务商平台完成支付后，您的加密货币将在大约2-10分钟内存入您的SuperEx现货账户。',
  300400: '6、购买过程中遇到问题怎么办？',
  300401: '如果您在交易过程中遇到任何问题，请联系客户支持。如果您付款完成后仍未收到加密货币，请联系第三方服务提供商检查 订单详细信息（这通常是最有效的方法）。由于您当前所在地区的IP或某些政策原因，您必须选择人工验证。',
  300402: "可用余额",
  300403: '余额不足',
  300404: '请输入币种',
  300405: '请输入法币',
  300406: '您尚未完成身份认证',
  300407: "为了您与您交易用户的账号安全，请先完成身份认证",
  300408: '去认证',
  300409: '暂不认证',
  300410: '选择币种',
  300411: '选择法币',
  300412: '全部币种',
  300413: '全部法币',
  300414: '约{time}分钟',
  300415: 'P2P交易暂不对钱包授权用户开放，请使用SuperEx账号登录后进行P2P交易',
  300416: 'https://support.superex.com/hc/zh-hk/articles/23083845808537',
  300417: '购买',
  300418: '序号',
  300419: 'SuperEx萬聖節嘉年華',
  300420: '簽到享好禮，交易贏獎金！',
  300421:'类型',
  300422:'币种奖励',
  300423:'',
  300424:'',

  400000:'全球首家基于Web3加密货币交易所',
  400001:'加入我们，共创自由的金融世界',
  400002:'你的每一筆交易將助於我們推動人類對火星以及宇宙的探索！',
  400003:'SuperEX精彩瞬间回顾',
  400004:'每一个精彩瞬间，都是我们足迹的见证和前行的力量',
  400005:'选择语言和地区',
  400006:'0风险',
  400007:'无KYC',
  400008:'自由无边界',
  400009:'基金',
  400010:'主网浏览器',
  400011:'测试网浏览器',
  400012:'开发者文档',
  400013:'其他',
  400014:'ET 专区',
  400015:'',

  400017: '输入11位手机号码',

  ...zhLocal,
  ...zhJame,
  ...zhGaea,
  ...zhAllen
}
export default zh;



// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js